

export default class BackgroundFileTranslationsRequest  {
	Id: string = '';
	LangCode?: string = '';
	Name?: string = '';
	constructor(obj?: Partial<BackgroundFileTranslationsRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
